module.exports = __webpack_public_path__ + "img/21_35.16b8a221.png";